import { useState, useEffect } from 'react';
import { Box, Card, Divider, Grid, Typography, useTheme } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { ButtonBasic, DateRangeMaxSeven, SelectUser } from '../../components';
import FechaFunction from '../../function/FechaFunction';
import DashboardService from '../../services/dashboard.service';
import Select from 'react-select';

function ModalFilterDashPreServicios({
    show,
    hideModal,
    filtroTotal,
    setFiltroTotal,
    setCountFilter,
    itemsOriginal,
    primeraCarga,
    setItems,
    fechaSelect,
    setFechaSelect,
    setItemsOriginal
}) {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const handleClose = () => hideModal();
    const [isLoading, setIsLoading] = useState(false);
    const [estado, setEstado] = useState(filtroTotal?.estado || []);
    const [fase, setFase] = useState(filtroTotal?.fase || []);
    const [tecnologia, setTecnologia] = useState(filtroTotal?.tecnologia || []);
    const [creadoPor, setCreadoPor] = useState(filtroTotal?.autorId || []);
    const [fechas, setFechas] = useState({
        startDate: new Date(),
        endDate: new Date()
    });

    useEffect(() => {
        if (fechaSelect?.startDate && fechaSelect?.endDate) {
            let startDate, endDate;
            if (typeof fechaSelect.startDate === 'string') {
                startDate = new Date(fechaSelect.startDate + 'T00:00:00');
            } else {
                startDate = new Date(fechaSelect.startDate);
            }
            if (typeof fechaSelect.endDate === 'string') {
                endDate = new Date(fechaSelect.endDate + 'T00:00:00');
            } else {
                endDate = new Date(fechaSelect.endDate);
            }
            setFechas({ startDate, endDate });
        }
    }, [fechaSelect]);

    const nuevoFiltro = (itemsOrigin) => {
        if (estado?.length > 0) {
            itemsOrigin = itemsOrigin.filter(obj => estado.includes(obj.estadoServicio_t));
        }
        if (fase?.length > 0) {
            itemsOrigin = itemsOrigin.filter(obj => fase.includes(obj.faseNombre));
        }
        if (tecnologia?.length > 0) {
            itemsOrigin = itemsOrigin.filter(obj => tecnologia.includes(obj.tipoTecnologiaCalc));
        }
        if (creadoPor?.length > 0) {
            itemsOrigin = itemsOrigin.filter(obj => creadoPor.includes(obj.createdPersonaId_t));
        }
        primeraCarga(itemsOrigin);
        setItems(itemsOrigin);
    };

    const onSubmit = async () => {
        setIsLoading(true);
        setFiltroTotal({
            ...filtroTotal,
            estado,
            fase,
            tecnologia,
            autorId: creadoPor,
        });
        const suma = estado?.length + fase?.length + tecnologia?.length + creadoPor?.length;
        setCountFilter(suma);

        const fechaIni = fechas?.startDate ? FechaFunction.format(fechas.startDate, 'yyyy-MM-dd') : null;
        const fechaFin = fechas?.endDate ? FechaFunction.format(fechas.endDate, 'yyyy-MM-dd') : null;

        try {
            const resp = await DashboardService.gralPreServicio({
                fecIni: fechaIni,
                fecFin: fechaFin,
                estado,
                fase,
                tecnologia,
                autorId: creadoPor
            });
            const data = resp?.data || resp;
            setFechaSelect({ startDate: fechaIni, endDate: fechaFin });
            setItemsOriginal(data);
            primeraCarga(data);
            setItems(data);
        } catch (error) {
            console.error('Error al cargar datos:', error);
        }
        setIsLoading(false);
        handleClose();
    };

    // Simple inline select for estado/fase/tecnologia using react-select pattern
    const estadoOptions = [
        { value: 'FECHA PENDIENTE DE ASIGNAR', label: 'Fecha Pendiente de Asignar' },
        { value: 'FECHA ASIGNADA', label: 'Fecha Asignada' },
        { value: 'EN ESPERA DE DA', label: 'En Espera de DA' },
        { value: 'A REPROGRAMAR', label: 'A Reprogramar' },
        { value: 'INSTALADO', label: 'Instalado' },
        { value: 'CANCELADO', label: 'Cancelado' },
        { value: 'SIN COBERTURA', label: 'Sin Cobertura' },
        { value: 'NO LE INTERESA', label: 'No Le Interesa' },
    ];

    const tecnologiaOptions = [
        { value: 'FO', label: 'Fibra Óptica' },
        { value: 'RE', label: 'Radio Enlace' },
    ];

    return (
        <Dialog open={show} disableEscapeKeyDown maxWidth='md' fullWidth className='side'>
            <Box sx={{ background: isDarkMode ? '#2d3a52' : '#fff' }} className='side'>
                <DialogTitleDefault id="filter-pre-servicios" onClose={handleClose}>
                    <Typography sx={{ flex: 1, textAlign: 'center', color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold' }} variant='h5'>
                        FILTRAR DATOS - PRE-SERVICIOS
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{ background: isDarkMode ? '#3d4a62' : 'gray' }} />
                <DialogContent className='side'>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Card sx={{ boxShadow: 4, borderRadius: 4, background: isDarkMode ? '#1F2A40 !important' : '#fff !important', p: 2 }}>
                                <Typography sx={{ color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold', textAlign: 'center' }}>
                                    Rango de Fechas
                                </Typography>
                                <DateRangeMaxSeven
                                    minDate={new Date('2023-11-01')}
                                    initianDate={fechas}
                                    onChange={(e) => {
                                        let startDate, endDate;
                                        if (e?.startDate) {
                                            startDate = new Date(e.startDate);
                                            startDate.setHours(0, 0, 0, 0);
                                        }
                                        if (e?.endDate) {
                                            endDate = new Date(e.endDate);
                                            endDate.setHours(23, 59, 59, 999);
                                        } else if (e?.startDate) {
                                            endDate = new Date(e.startDate);
                                            endDate.setHours(23, 59, 59, 999);
                                        }
                                        if (e?.startDate) {
                                            setFechas({ startDate, endDate });
                                        }
                                    }}
                                />
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <Typography sx={{ color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold' }}>Estado</Typography>
                            <SelectMultiInline
                                options={estadoOptions}
                                value={estado}
                                onChange={setEstado}
                                isDarkMode={isDarkMode}
                                placeholder="Seleccione estado..."
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <Typography sx={{ color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold' }}>Tecnología</Typography>
                            <SelectMultiInline
                                options={tecnologiaOptions}
                                value={tecnologia}
                                onChange={setTecnologia}
                                isDarkMode={isDarkMode}
                                placeholder="Seleccione tecnología..."
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <Typography sx={{ color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold' }}>Creado por:</Typography>
                            <SelectUser
                                isMulti
                                filter='all'
                                value={creadoPor}
                                onChange={(opt) => {
                                    setCreadoPor(opt.map(op => op.value));
                                }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
                    <ButtonBasic
                        textButton='Cancelar'
                        variant='wk'
                        color='cancel'
                        onClick={() => handleClose()}
                        sx={{ mb: 2 }}
                    />
                    <ButtonBasic
                        textButton='Guardar'
                        variant='wk'
                        color='nextStep'
                        onClick={() => onSubmit()}
                        sx={{ mb: 2 }}
                        isLoading={isLoading}
                    />
                </DialogActions>
            </Box>
        </Dialog>
    );
}

// Simple multi-select component using react-select
const SelectMultiInline = ({ options, value, onChange, isDarkMode, placeholder }) => {
    const selected = options.filter(o => value.includes(o.value));
    const customStyles = {
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        menu: (provided) => ({ ...provided, backgroundColor: isDarkMode ? '#2d3a52' : '#fff' }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? (isDarkMode ? '#90caf9' : '#fff') : (isDarkMode ? '#e0e0e0' : '#000'),
            background: state.isSelected ? (isDarkMode ? '#1a3a5c' : '#0364ff') : (isDarkMode ? '#2d3a52' : '#fff'),
            '&:hover': { backgroundColor: isDarkMode ? '#3d4a62' : '#02378c', color: isDarkMode ? '#e0e0e0' : '#fff' },
        }),
        control: (styles) => ({ ...styles, borderRadius: 7, borderColor: isDarkMode ? '#3d4a62' : 'gray', backgroundColor: isDarkMode ? '#2d3a52' : '#fff' }),
        singleValue: (styles) => ({ ...styles, color: isDarkMode ? '#e0e0e0' : '#000' }),
        input: (styles) => ({ ...styles, color: isDarkMode ? '#e0e0e0' : '#000' }),
        placeholder: (styles) => ({ ...styles, color: isDarkMode ? '#b0bec5' : 'gray' }),
        multiValue: (styles) => ({ ...styles, backgroundColor: isDarkMode ? '#1a3a5c' : '#0364ff', borderRadius: 5, border: isDarkMode ? '1px solid #fff' : 'none' }),
        multiValueLabel: (styles) => ({ ...styles, color: '#fff', borderRadius: 5 }),
        multiValueRemove: (styles) => ({ ...styles, color: '#fff', borderRadius: 5, '&:hover': { backgroundColor: '#02378c', color: '#fff' } }),
    };
    return (
        <Select
            isMulti
            isClearable
            options={options}
            value={selected}
            onChange={(opt) => onChange(opt ? opt.map(o => o.value) : [])}
            styles={customStyles}
            menuPortalTarget={document.body}
            placeholder={placeholder}
        />
    );
};

export default ModalFilterDashPreServicios;
